<template>
    <div class="session__show_feedback_item">
        <div class="session__show_feedback_item_top">
            <div class="columns is-vcentered">
                <div class="column">
                    <div class="session__show_feedback_item_content_details_list_trainers">
                        {{ session.name }}
                    </div>
                </div>
            </div>
        </div>
        <template v-for="(item, index) in session.occurrenceItems">
            <div
                class="session__show_feedback_item_bottom"
                :key="index"
            >
                <div class="columns is-vcentered">
                    <div class="column column--custom-flex">
                        <div class="session__show_feedback_item_bottom_description_time">
                            <template v-if="toLocaleDateTime(item.dateStart) === toLocaleDateTime(item.dateEnd)">
                                {{toLocaleDateTime(item.dateStart)}} | {{toLocaleTime(item.dateStart).toUpperCase()}} -
                                {{toLocaleTime(item.dateEnd).toUpperCase()}}
                            </template>
                            <template v-else>
                                {{toLocaleDateTime(item.dateStart)}} - {{toLocaleDateTime(item.dateEnd)}} |
                                {{toLocaleTime(item.dateStart).toUpperCase()}} -
                                {{toLocaleTime(item.dateEnd).toUpperCase()}}
                            </template>
                        </div>
                    </div>
                    <div class="column column--right is-narrow">
                        <div class="columns custom--padding is-vcentered">
                            <div class="column">
                                <div class="session__show_feedback_item_bottom_status">
                                    <component-status :status="item.feedback === null ? `not-completed` : `completed`"/>
                                </div>
                            </div>
                            <div class="column is-narrow">
                                <div class="session__show_feedback_item_bottom_actions">
                                    <component-button
                                        @click="openNotifyFeedbackForm(item, index, trainerId)"
                                        :name="`session-show-feedback-item-bottom-actions-view-${index}`"
                                    >{{ $t('ebs.sessions.show.buttons.view') }}
                                    </component-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <pop-notify
            ref="formfeedback"
            :class="'pop__notify--booking'"
            :title-text="$t('ebs.sessions.show.title.trainerFeedback')"
            :form-active="true"
            :form-fields="sessionFeedbackForm"
            :cancel-button-text="$t('ebs.sessions.show.buttons.cancel')"
            :submit-button-text="$t('ebs.sessions.show.buttons.save')"
            :content-text="$t('ebs.sessions.show.notify.pleaseCompleteThe')"
            @emit-form="updateFeedbackFields"
            @emit-submit="submitSessionFeedback"
        />
    </div>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  components: {
    ComponentButton,
    ComponentStatus,
    PopNotify
  },
  name: 'session-show-feedback-item',
  props: {
    session: {
      type: [Object, String],
      default: () => {
      },
      required: true
    },
    date: {
      type: String,
      default: ''
    },
    trainerId: {
      type: String,
      default: ''
    }
  },
  computed: {
    defaultSessionFeedbackForm () {
      return this.$store.getters.getSessionCompletionFormFields
    },
    sessionFeedbackForm () {
      return this.$store.getters.getSessionFeedbackForm
    }
  },
  methods: {
    openNotifyFeedbackForm (data, index, trainerId) {
      const feedbackForm = data.feedback ? JSON.parse(JSON.stringify(data.feedback.feedback)) : JSON.parse(JSON.stringify(this.defaultSessionFeedbackForm))
      const feedbackId = data.feedback ? (data.feedback.id || null) : null
      this.$store.dispatch('clearSessionFeedback')
      this.$store.dispatch('setSessionFeedbackId', feedbackId)
      this.$store.dispatch('setSessionFeedbackForm', feedbackForm)
      this.$store.dispatch('setSessionFeedbackTrainerId', trainerId)
      this.$store.dispatch('setSessionFeedbackOccurrenceItemId', index)
      this.$store.dispatch('setSessionFeedbackIsNewFeedback', data.feedback === null)
      this.$refs.formfeedback.openNotify(data)
    },
    submitSessionFeedback (data) {
      this.$store.dispatch('submitSessionFeedback', data).then(() => {
        this.$eventBus.$emit('perform-get-session')
      })
    },
    updateFeedbackFields (data) {
      this.$store.dispatch('updateSessionFeedbackForm', data)
    }
  }
}
</script>
